import React from "react";
import axios from "axios";
import { Truck, Award, TrendingUp, AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const dkk = (n) => `${Math.round(Number(n) || 0).toLocaleString("da-DK")} kr`;

export default function DriverStatsPanel({ token }) {
  const [drivers, setDrivers] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/admin/driver-stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDrivers(data.drivers || []);
      } catch (e) {
        console.error("driver stats failed", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  if (loading) return <div className="text-brand-text2" data-testid="driver-stats-loading">Indlæser chauffør-statistik...</div>;

  return (
    <div data-testid="driver-stats-panel" className="space-y-4">
      <div className="bg-white border border-brand p-5">
        <div className="flex items-center gap-2 mb-2">
          <Truck size={18} className="text-brand-red" />
          <div>
            <div className="text-xs uppercase tracking-widest text-brand-text2 font-semibold">Chauffør-statistik</div>
            <div className="font-display text-lg text-brand-dark">Performance sidste 30 dage</div>
          </div>
        </div>
        {drivers.length === 0 ? (
          <div className="text-brand-text2 text-sm mt-4">Ingen chauffør-data endnu.</div>
        ) : (
          <table className="w-full mt-4 text-sm">
            <thead>
              <tr className="border-b border-brand">
                <th className="text-left py-2 text-xs uppercase tracking-widest text-brand-text2">Chauffør</th>
                <th className="text-right py-2 text-xs uppercase tracking-widest text-brand-text2">Leveringer 30d</th>
                <th className="text-right py-2 text-xs uppercase tracking-widest text-brand-text2">Total leveringer</th>
                <th className="text-right py-2 text-xs uppercase tracking-widest text-brand-text2">Omsætning</th>
                <th className="text-right py-2 text-xs uppercase tracking-widest text-brand-text2">Fejlet</th>
                <th className="text-right py-2 text-xs uppercase tracking-widest text-brand-text2">Status</th>
              </tr>
            </thead>
            <tbody>
              {drivers.map((d, i) => {
                const isTop = i === 0 && d.deliveries_30d > 0;
                return (
                  <tr key={d.driver_id} className="border-b border-brand last:border-b-0">
                    <td className="py-3">
                      <div className="flex items-center gap-2">
                        {isTop && <Award size={14} className="text-amber-500" />}
                        <span className="font-semibold text-brand-dark">{d.name}</span>
                      </div>
                      <div className="text-xs text-brand-text2">{d.email}</div>
                    </td>
                    <td className="text-right py-3 font-display font-bold">{d.deliveries_30d}</td>
                    <td className="text-right py-3">{d.deliveries_all}</td>
                    <td className="text-right py-3 font-semibold">{dkk(d.revenue_handled)}</td>
                    <td className="text-right py-3">
                      {d.failed_deliveries > 0 ? (
                        <span className="text-red-600 inline-flex items-center gap-1">
                          <AlertTriangle size={12} />{d.failed_deliveries}
                        </span>
                      ) : (
                        <span className="text-brand-text2">0</span>
                      )}
                    </td>
                    <td className="text-right py-3">
                      <span className={`text-xs px-2 py-1 ${d.active ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                        {d.active ? "Aktiv" : "Inaktiv"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      <div className="bg-brand-bg border border-brand p-4 text-xs text-brand-text2 leading-relaxed">
        <div className="flex items-center gap-2 mb-1"><TrendingUp size={12} /><span className="font-semibold uppercase tracking-widest">Top performer</span></div>
        Den chauffør med flest leveringer i de sidste 30 dage får automatisk en stjerne ved navnet. Omsætning viser den samlede betalte omsætning chaufføren har håndteret.
      </div>
    </div>
  );
}
